import styled from '@emotion/styled';
import {EventContentArg} from '@fullcalendar/core';
import React from 'react';
import {mixinFlexboxRow} from 'webapp-lib/styling';

import {
  CalendarWorkLogExtendedProps,
  EventApiWithWorkLogProps,
  EventTimers,
  TimerStartData,
} from '../types';

import {PlayButton} from './PlayButton';

export const Event = ({
  eventInfo,
  timer,
  recordingEvent,
}: {
  eventInfo: EventContentArg;
  timer: EventTimers;
  recordingEvent: EventApiWithWorkLogProps | null;
}): React.ReactElement => {
  const extendedProps = eventInfo.event
    .extendedProps as CalendarWorkLogExtendedProps;

  const casusDisplayName = extendedProps?.activity?.displayName;
  const isTracking = recordingEvent?.id === eventInfo.event.id;

  const timerData: TimerStartData = {
    title: eventInfo.event.title,
    description: extendedProps?.description,
    color: eventInfo.backgroundColor,
    activity: extendedProps.activity,
  };

  return (
    // default renderInnerContent taken from https://github.com/fullcalendar/fullcalendar/blob/3b56ca2d741a449b32f02548b0cec0bf06d3d368/packages/core/src/common/StandardEvent.tsx#L75-L88
    <div className='fc-event-main-frame'>
      <EventHeader>
        {eventInfo.timeText && (
          <div className='fc-event-time'>{eventInfo.timeText}</div>
        )}
        <PlayButton
          isRunning={isTracking}
          startTimer={() => timer.start(timerData)}
          stopTimer={timer.stop}
        />
      </EventHeader>
      <div className='fc-event-title-container'>
        <div className='fc-event-title fc-sticky'>
          {casusDisplayName && (
            <AdditionalEventInfo>{casusDisplayName}</AdditionalEventInfo>
          )}
          <EventTitle>{eventInfo.event.title}</EventTitle>
        </div>
      </div>
    </div>
  );
};

const EventHeader = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
`;

export const AdditionalEventInfo = styled.div`
  display: inline-block;
`;

const EventTitle = styled.div`
  font-weight: bold;
`;
